import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useFetch from "../../../../hooks/useFetch";
import { getUsername } from "../../../../services/Authentification/authentification";
import { ErrorApi } from "../../../../types";

export const useAjoutAdherent = (setOpenAjoutAdherent) => {
  const login = getUsername();
  // ------------
  // INIT FORMULAIRE
  // ------------
  const methods = useForm<{ numeroAdhesion: number }>({
    mode: "onBlur",
    reValidateMode: "onBlur",
    criteriaMode: "all",
    defaultValues: {},
  });
  const {
    watch,
    handleSubmit,
    formState: { errors },
    register,
    setValue,
    clearErrors,
  } = methods;

  const [paramsAjouterAdherent, setParamsAjouterAdherent] = useState<
    { login: number; numeroAdhesion: number } | undefined
  >();
  const onSubmit = (data) => {
    setParamsAjouterAdherent({ login, numeroAdhesion: data });
  };
  const { response, fetching, error } = useFetch(
    paramsAjouterAdherent,
    "ajouterAdherent",
    paramsAjouterAdherent && paramsAjouterAdherent.numeroAdhesion ? true : false
  );

  const [errorApi, setErrorApi] = useState<ErrorApi | undefined>();
  const [
    confirmationAjoutAdherent,
    setConfirmationAjoutAdherent,
  ] = useState<boolean>(false);

  useEffect(() => {
    setErrorApi(error);
  }, [error]);

  useEffect(() => {
    if (response) {
      setOpenAjoutAdherent(false);
      setConfirmationAjoutAdherent(true);
    }
  }, [response]);
  return {
    methods,
    watch,
    handleSubmit,
    errors,
    register,
    setValue,
    clearErrors,
    onSubmit,
    response,
    fetching,
    setErrorApi,
    errorApi,
    confirmationAjoutAdherent,
    setConfirmationAjoutAdherent,
  };
};
